/**
 * Shopify system policy pages (/policies/refund-policy) ignore theme templates.
 * This rewrites the policy body with clear rules + support email.
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var path = (window.location.pathname || '').toLowerCase();
    if (path.indexOf('/policies/refund') === -1 && path.indexOf('/policies/return') === -1) {
      return;
    }

    var body = document.querySelector('.shopify-policy__body .rte, .shopify-policy__body');
    if (!body) return;

    var email = 'support@whiffsofparadise.com';
    body.innerHTML =
      '<p><strong>The short version:</strong> Returns are only accepted if the perfume is <strong>damaged</strong>, <strong>leaked in transit</strong>, or the <strong>wrong product</strong> was delivered — not for change of mind or preference.</p>' +
      '<p><strong>A clear, continuous unboxing video is mandatory for every claim.</strong> Without it, the claim will be rejected.</p>' +
      '<p>Email claims to <a href="mailto:' +
      email +
      '"><strong>' +
      email +
      '</strong></a> within <strong>24 hours of delivery</strong>, with your Order ID and unboxing video.</p>' +
      '<h2>1. Damage only — eligible cases</h2>' +
      '<ul>' +
      '<li>The product is damaged</li>' +
      '<li>Leakage has occurred during transit</li>' +
      '<li>An incorrect product is delivered</li>' +
      '</ul>' +
      '<h2>2. Report within 24 hours</h2>' +
      '<p>All issues must be reported within <strong>24 hours of delivery</strong>. Requests received after this period will not be accepted.</p>' +
      '<h2>3. Mandatory unboxing video</h2>' +
      '<p>A clear, continuous unboxing video from sealed package to product opening is mandatory for all claims. Claims without an unboxing video will be rejected.</p>' +
      '<h2>How to claim</h2>' +
      '<ol>' +
      '<li>Email <a href="mailto:' +
      email +
      '">' +
      email +
      '</a> within 24 hours of delivery</li>' +
      '<li>Include your Order ID</li>' +
      '<li>Attach a clear, continuous unboxing video (sealed package to product opening)</li>' +
      '<li>Describe the damage, leakage, or wrong item</li>' +
      '</ol>' +
      '<h2>No return on opened products</h2>' +
      '<p>Opened, used, or tampered perfumes are not eligible for return, exchange, or refund. Fragrance preference and change-of-mind purchases are not covered.</p>' +
      '<h2>Resolution</h2>' +
      '<p>Upon verification, we may offer:</p>' +
      '<ul>' +
      '<li>A replacement product, or</li>' +
      '<li>Store credit</li>' +
      '</ul>' +
      '<p>Refunds to the original payment method are issued only in exceptional cases at the discretion of Whiffs of Paradise.</p>' +
      '<h2>Refund processing time</h2>' +
      '<ul>' +
      '<li>Online payments: 5–7 business days</li>' +
      '<li>COD orders: bank transfer or store credit</li>' +
      '</ul>' +
      '<h2>Non-returnable items</h2>' +
      '<ul>' +
      '<li>Opened or used products</li>' +
      '<li>Change-of-mind purchases</li>' +
      '<li>Fragrance preference issues</li>' +
      '<li>Minor packaging imperfections</li>' +
      '<li>Tester packaging variations</li>' +
      '</ul>' +
      '<h2>Condition for approved returns</h2>' +
      '<p>When a return is approved, products must be unused, unopened, and in original packaging with all accessories and free gifts.</p>' +
      '<h2>Policy abuse</h2>' +
      '<p>Whiffs of Paradise reserves the right to refuse service or block accounts involved in misuse of return or refund policies.</p>';

    body.setAttribute('data-refund-policy-enhanced', 'true');
  });
})();
